import { JUSTIFICATIVA_MAX_LENGTH } from "@/shared/components/equipe-obra/equipe-obra.constants";

/** Justificativa única do Salvar (campo de 255 no core), com conflito e indisponibilidade juntos. */

const PREFIXO_CONFLITO = "Conflito: ";
const PREFIXO_INDISPONIBILIDADE = "\nIndisponibilidade: ";

/**
 * Tamanho máximo da justificativa de cada modal. Com conflito e indisponibilidade no mesmo
 * Salvar as duas viajam juntas num único campo de 255; o conflito (primeiro modal) fica
 * com metade do que sobra após os prefixos e a indisponibilidade com o restante, para que
 * a junção nunca precise cortar texto digitado.
 */
export function limiteJustificativa(
  etapa: "conflitos" | "indisponivel",
  ambas: boolean,
  conflitoUsado = 0,
): number {
  if (!ambas) return JUSTIFICATIVA_MAX_LENGTH;
  const livre =
    JUSTIFICATIVA_MAX_LENGTH - PREFIXO_CONFLITO.length - PREFIXO_INDISPONIBILIDADE.length;
  return etapa === "conflitos" ? Math.floor(livre / 2) : livre - conflitoUsado;
}

/**
 * Uma justificativa por POST: com conflito e indisponibilidade, as duas vão juntas,
 * identificadas (os limites de `limiteJustificativa` evitam o corte; o slice só protege o
 * limite do core).
 */
export function combinarJustificativas({
  conflito,
  indisponibilidade,
}: {
  conflito?: string;
  indisponibilidade?: string;
}): string | undefined {
  if (conflito && indisponibilidade) {
    return `${PREFIXO_CONFLITO}${conflito}${PREFIXO_INDISPONIBILIDADE}${indisponibilidade}`.slice(
      0,
      JUSTIFICATIVA_MAX_LENGTH,
    );
  }
  return conflito || indisponibilidade || undefined;
}
